export const products = [
  {
    id: 1,
    name: "Family Habit Tracker Journal",
    price: 24.99,
    image: "https://public.readdy.ai/ai/img_res/ed55b0dc3978ea367545d367e33e673e.jpg",
    category: "Journals",
    description: "Track your family's micro-habits with this beautifully designed 90-day journal."
  },
  {
    id: 2,
    name: "Seven Pillars Wall Art Print",
    price: 34.99,
    image: "https://readdy.ai/api/search-image?query=minimalist%20wall%20art%20print%20with%20seven%20pillars%20text%20modern%20typography%20warm%20neutral%20tones%20simple%20clean%20background%20home%20decor%20inspirational%20design&width=600&height=600&seq=prod2&orientation=squarish",
    category: "Home Decor",
    description: "Beautiful reminder of the seven pillars to display in your home."
  },
  {
    id: 3,
    name: "Family Devotional Cards Deck",
    price: 18.99,
    image: "https://readdy.ai/api/search-image?query=deck%20of%20devotional%20cards%20spread%20on%20table%20elegant%20design%20faith%20based%20content%20warm%20lighting%20simple%20clean%20background%20product%20photography&width=600&height=600&seq=prod3&orientation=squarish",
    category: "Faith",
    description: "52 weekly devotional prompts designed for families to grow together in faith."
  },
  {
    id: 4,
    name: "Micro-Habits Starter Kit",
    price: 49.99,
    image: "https://readdy.ai/api/search-image?query=starter%20kit%20box%20with%20journal%20cards%20and%20stickers%20organized%20neatly%20on%20white%20surface%20warm%20natural%20light%20minimalist%20product%20photography%20lifestyle%20aesthetic&width=600&height=600&seq=prod4&orientation=squarish",
    category: "Bundles",
    description: "Everything you need to start building transformative family habits today."
  },
  {
    id: 5,
    name: "Fitness Challenge Cards for Families",
    price: 16.99,
    image: "https://readdy.ai/api/search-image?query=colorful%20fitness%20challenge%20cards%20for%20families%20laid%20out%20on%20table%20active%20lifestyle%20theme%20bright%20clean%20background%20product%20photography&width=600&height=600&seq=prod5&orientation=squarish",
    category: "Fitness",
    description: "30 fun fitness challenges that get the whole family moving together."
  },
  {
    id: 6,
    name: "Weekly Meal Planning Pad",
    price: 14.99,
    image: "https://readdy.ai/api/search-image?query=meal%20planning%20notepad%20on%20kitchen%20counter%20with%20fresh%20vegetables%20nearby%20organized%20layout%20warm%20natural%20lighting%20simple%20clean%20background&width=600&height=600&seq=prod6&orientation=squarish",
    category: "Food",
    description: "Simplify meal prep with this tear-off planning pad designed for busy families."
  },
  {
    id: 7,
    name: "Financial Wisdom Workbook",
    price: 22.99,
    image: "https://readdy.ai/api/search-image?query=financial%20planning%20workbook%20on%20desk%20with%20calculator%20and%20pen%20professional%20clean%20design%20warm%20lighting%20simple%20white%20background%20product%20photography&width=600&height=600&seq=prod7&orientation=squarish",
    category: "Finances",
    description: "Teach your children financial stewardship through practical exercises and activities."
  },
  {
    id: 8,
    name: "Friendship Connection Cards",
    price: 15.99,
    image: "https://readdy.ai/api/search-image?query=friendship%20conversation%20cards%20in%20elegant%20box%20warm%20inviting%20design%20simple%20clean%20background%20natural%20lighting%20product%20photography&width=600&height=600&seq=prod8&orientation=squarish",
    category: "Friends",
    description: "Deepen relationships with meaningful conversation starters for all ages."
  }
];

export const featuredProducts = products.slice(0, 4);